import { render, staticRenderFns } from "./BarcodeListSettings.vue?vue&type=template&id=57bfdd6e&scoped=true"
import script from "./BarcodeListSettings.vue?vue&type=script&lang=ts"
export * from "./BarcodeListSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bfdd6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57bfdd6e')) {
      api.createRecord('57bfdd6e', component.options)
    } else {
      api.reload('57bfdd6e', component.options)
    }
    module.hot.accept("./BarcodeListSettings.vue?vue&type=template&id=57bfdd6e&scoped=true", function () {
      api.rerender('57bfdd6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/BarcodeListSettings.vue"
export default component.exports